import React from 'react'

const React_Coding_Practice_6 = () => {
  return (
    <div>
      <h1>Coding Pratice 6</h1>
    </div>
  )
}

export default React_Coding_Practice_6
